import { Components, Theme } from '@mui/material'
import { palette } from '../palette'

export const MuiToggleButtonGroup: Components<Omit<Theme, 'components'>>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: {
      '& .MuiToggleButton-root': {
        fontSize: 13,
        gap: 4,
        textTransform: 'none',
        padding: '2px 16px',
        borderColor: palette.purple[500],
        backgroundColor: palette.neutralLight[50],
        '& .MuiSvgIcon-root': {
          width: 18,
          height: 18,
        },
        '&.Mui-selected': {
          backgroundColor: palette.purple[50],
        },
        '&.MuiToggleButtonGroup-grouped:not(:first-of-type), &.MuiToggleButtonGroup-grouped:not(:last-of-type)': {
          borderLeftColor: palette.purple[500],
          borderRightColor: palette.purple[500],
        },
      },
    },
  },
}
